export enum DayPartOffset {
  Morning = 0.125,
  Noon = 0.375,
  Evening = 0.625,
  Night = 0.875,
}

export default {};
